/*
 * This file is part of rob006/flarum-ext-last-post-avatar.
 *
 * Copyright (c) 2023 Robert Korulczyk <robert@korulczyk.pl>
 *
 * This source file is subject to the MIT license that is bundled
 * with this source code in the file LICENSE.
 */

import app from 'flarum/common/app';

app.initializers.add('rob006/flarum-ext-last-post-avatar', () => {
	// console.log('[rob006/flarum-ext-last-post-avatar] Hello, forum and admin!');
});
